import { Injectable } from '@angular/core';
import { Assessment } from 'app/shared/models/assessment';
import { ScaleResult } from 'app/shared/models/scale-result';
import { AssessmentResult } from 'app/shared/models/assessment-result';

@Injectable()
export class ScaleResultQuestionFinderService {

  constructor() { }

  public getQuestionsForScaleResult(assessmentResult:AssessmentResult, scaleResult:ScaleResult, depth = 0) {
    let questionList = [];
    if (depth > 50) {
      console.error("Max recursive depth reached");
      return questionList;
    }
    if (this.hasSubScales(scaleResult)) {
      let subScaleResults = this.getSubScales(assessmentResult, scaleResult);
      questionList = subScaleResults.map(sr => this.getQuestionsForScaleResult(assessmentResult, sr, depth + 1))
                    .reduce((prev, curr) => prev.concat(curr), []);
    }
    else {
      questionList = assessmentResult.assessment.getQuestionsForScale(scaleResult.scale);
    }
    return questionList;
  }

  private hasSubScales(scaleResult:ScaleResult) {
    return scaleResult && scaleResult.scale && scaleResult.scale.hasSubScales();
  }

  private getSubScales(assessmentResult, scaleResult:ScaleResult) :ScaleResult[]{
    if (scaleResult.scale.hasSubScales()) {
      return scaleResult.scale.getSubScaleIds().map(si => assessmentResult.getScaleResultByScaleId(si));
    }
    return [];
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/services/scale-result-question-finder.service.ts